import AppContext from "../../../application/AppContext";
import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isLoading: false, // 加载
    UnitTree: [], // 所有科室
    units: [], // 显示数据
    expandedUnits: [], // 展开的科室
    isSearchMode: false, // 是否搜索

    editModalVisible: false, // 编辑窗口
    editSpecTypeModalVisible: false,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
